const choices = {
    rebuy: 'Je demande un rachat total ',
    advice: 'Je demande un conseil',
    arbitration: 'Je demande un arbitrage',
    waiting: 'J\'attends un retour à la situation d\'origine ',
};

export default choices;
